export default  {"src":"/_next/static/image/public/assets/nevo-boi/close.44628e70832c998026b6dc1e5f8b68b2.svg","height":22,"width":22};